module.exports = __webpack_public_path__ + "static/media/we3academy_gridexample_cocacola.e7208ed5.jpg";